import { useQuery } from '@hooks/reactQuery';

import { getDownloadHistoryStatuses } from '@api/downloadHistory';

import { nameTitleToOptionFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { allowedRolesDownloadHistory } from '@constants/downloadHistory';
import { DOWNLOAD_HISTORY_STATUSES } from '@constants/queryKeys';

interface UseQueryDownloadHistoryStatuses {
	statusesOptions: TSelectOption<string>[];
	isLoadingStatusesOptions: boolean;
}

export const useQueryDownloadHistoryStatuses = (): UseQueryDownloadHistoryStatuses => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [DOWNLOAD_HISTORY_STATUSES],
		allowedRoles: allowedRolesDownloadHistory,
		queryFn: getDownloadHistoryStatuses,
		select: nameTitleToOptionFormatted,
		...refetchOptions,
	});

	return {
		statusesOptions: data || [],
		isLoadingStatusesOptions: (isLoading && !!data)
			|| isFetching,
	};
};
